import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { admin_bp } from "@/config/roles";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { isAuthorized, isUserAdmin } from "@/redux/actions/auth";
import Omnisearch from "@/components/Common/Omnisearch";
import OmnisearchQuestions from "@/APIRequests/omnisearch";
import { setOmnisearchDisplayStatus } from "@/redux/actions/navbar";

import { DesktopToolbar } from "./Views/DesktopToolbar";
import "./styles.scss";

export function Toolbar({ baseRoute, isMessagingEnabled = true, navbarConfiguration }) {
  const dispatch = useDispatch();
  const dynamicRouteConfig = useSelector((state) => state.dynamicRouteConfig);
  const profile = useSelector((state) => state.auth.profile);

  const [displaySearchBar, setDisplaySearchBar] = useState(false);
  const [omnisearchQuestions, setOmnisearchQuestions] = useState([]);

  const handleClickSearch = () => {
    setDisplaySearchBar(!displaySearchBar);
    dispatch(setOmnisearchDisplayStatus(!displaySearchBar));

    if (!displaySearchBar) {
      setTimeout(() => {
        const inputElement = document.getElementById("omnisearch-input");

        if (inputElement) {
          inputElement.focus();
        }
      }, 0);
    }
  };

  useEffect(() => {
    if (!isAuthorized(admin_bp) && isUserAdmin()) {
      OmnisearchQuestions.fetch_provider_schedule_call_list().then((omnisearchQuestionBank) => {
        setOmnisearchQuestions(omnisearchQuestionBank);
      });
    }
  }, []);

  return (
    <>
      <header
        className="tw:min-h-(--header-height) tw:print:hidden"
        {...getAutomationDataAttr("main-header-section")}
      >
        <DesktopToolbar
          baseRoute={baseRoute}
          dynamicRouteConfig={dynamicRouteConfig}
          handleClickSearch={handleClickSearch}
          isMessagingEnabled={isMessagingEnabled}
          isSearchOpen={displaySearchBar}
          profile={profile}
          {...navbarConfiguration}
        />
      </header>

      {displaySearchBar && (
        <div className="omnisearch-dropdown">
          <Omnisearch id="omnisearch-input" questions={omnisearchQuestions} startFocused />
        </div>
      )}
    </>
  );
}
